import http from './http';

export async function createCase(payload) {
  const { data } = await http.post('/api/user/cases', payload);
  return data;
}

export async function listSecondaryHandlers() {
  const { data } = await http.get('/api/user/cases/secondary-handlers');
  return data;
}

export async function pageCases(params) {
  const { data } = await http.get('/api/user/cases/page', { params });
  return data;
}

export async function caseStats() {
  const { data } = await http.get('/api/user/cases/stats');
  return data;
}

export async function getCaseDetail(caseNo) {
  const { data } = await http.get(`/api/user/cases/${caseNo}`);
  return data;
}

export async function resubmitCase(caseNo, payload) {
  const { data } = await http.post(`/api/user/cases/${caseNo}/resubmit`, payload);
  return data;
}

export async function cancelCase(caseNo) {
  const { data } = await http.post(`/api/user/cases/${caseNo}/cancel`);
  return data;
}

export async function createDispute(caseNo, payload) {
  const { data } = await http.post(`/api/user/cases/${caseNo}/dispute`, payload);
  return data;
}

export async function markCaseSeen(caseNo) {
  const { data } = await http.post(`/api/user/cases/${caseNo}/seen`);
  return data;
}

export async function urgeCase(caseNo) {
  const { data } = await http.post(`/api/user/cases/${caseNo}/urge`);
  return data;
}

export async function urgeDispute(caseNo) {
  const { data } = await http.post(`/api/user/cases/${caseNo}/dispute/urge`);
  return data;
}

export async function getCaseRedDot() {
  const { data } = await http.get('/api/user/cases/red-dot');
  return data;
}

// Handler
export async function handlerPool() {
  const { data } = await http.get('/api/handler/pool');
  return data;
}

export async function handlerInProgress() {
  const { data } = await http.get('/api/handler/cases/in-progress');
  return data;
}

export async function handlerClosed() {
  const { data } = await http.get('/api/handler/cases/closed');
  return data;
}

export async function handlerClosedPage(params) {
  const { data } = await http.get('/api/handler/cases/closed/page', { params });
  return data;
}

export async function handlerCaseDetail(caseNo) {
  const { data } = await http.get(`/api/handler/cases/${caseNo}`);
  return data;
}

export async function takeCase(caseNo) {
  const { data } = await http.post(`/api/handler/cases/${caseNo}/take`);
  return data;
}

export async function releaseCase(caseNo) {
  const { data } = await http.post(`/api/handler/cases/${caseNo}/release`);
  return data;
}

export async function batchReleaseCases() {
  const { data } = await http.post('/api/handler/cases/batch-release');
  return data;
}

export async function replyReturn(caseNo, payload) {
  const { data } = await http.post(`/api/handler/cases/${caseNo}/reply-return`, payload);
  return data;
}

export async function replyClose(caseNo, payload) {
  const { data } = await http.post(`/api/handler/cases/${caseNo}/reply-close`, payload);
  return data;
}
